import { Button, DatePicker } from 'antd';
import dayjs, { type Dayjs } from 'dayjs';
import { useState } from 'react';

export interface DateRange {
  from: string | undefined;
  to: string | undefined;
}

interface JobDateRangeFilterProps extends DateRange {
  onApply: (range: DateRange) => void;
  close: () => void;
}

/**
 * A column `filterDropdown` for a `from`/`to` pair (gitaumoses4/chukua#39) — Ant's built-in
 * `filters` prop is one value per option, which doesn't fit a range, so this writes the two
 * query keys directly rather than going through the sorter/filter plumbing `useListQuery`
 * otherwise handles. No existing precedent in this codebase to reuse; kept deliberately small.
 */
export function JobDateRangeFilter({ from, to, onApply, close }: JobDateRangeFilterProps) {
  const [range, setRange] = useState<[Dayjs | null, Dayjs | null]>([from ? dayjs(from) : null, to ? dayjs(to) : null]);

  function apply() {
    onApply({ from: range[0]?.format('YYYY-MM-DD'), to: range[1]?.format('YYYY-MM-DD') });
    close();
  }

  function clear() {
    setRange([null, null]);
    onApply({ from: undefined, to: undefined });
    close();
  }

  return (
    <div className="flex flex-col gap-2 p-3">
      <DatePicker.RangePicker value={range} onChange={(value) => setRange(value ?? [null, null])} allowEmpty={[true, true]} />
      <div className="flex justify-end gap-2">
        <Button size="small" onClick={clear}>
          Clear
        </Button>
        <Button size="small" type="primary" onClick={apply}>
          Apply
        </Button>
      </div>
    </div>
  );
}
